export const ROLES = {
    Customer: 'Клиент',
    Employee: 'Сотрудник',
    Manager: 'Менеджер',
    Admin: 'Админ',
    SuperAdmin: 'Директор',
    Owner: 'Владелец',
}